import React from 'react'
import { EmployeeHeader } from '../Components/Header/EmployeeHeader'
import { EmployeeRightSide } from '../Components/RightSide/EmployeeRightSide'
import classes from './EmployeeLayout.module.css'
interface Props{
    children: React.ReactNode,
 

}

export const EmployeeLayout: React.FC<Props> = (props)=>{
    
    
    return(
        <div className={classes.main}>
            <div className={classes.content}>
                <EmployeeHeader  without/>
                <div className={classes.page +' pb-4'}>
                    {props.children}
                </div>
            </div>
            <EmployeeRightSide />
        </div>
)
}